export default __webpack_public_path__ + "img/d7856d3cef79919a23d53f4865ecc58c.svg";